// ** Redux Imports
import { Action } from 'redux'
import { ThunkDispatch } from '@reduxjs/toolkit'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { COUPON_HISTORY_SLICE_NAME, GET_COUPON_HISTORY_BY_USER_ID_ACTION } from './actions'
import type { AxiosInstance } from 'axios'
import { GygCouponHistoryType } from '@/src/types/apps/gygLoyaltyHistoryTypes'

type AxiosMiddlewareExtras = {
  httpClient: AxiosInstance
}

export type GygCouponHistoryStateType = {
  gygCouponHistory: GygCouponHistoryType[]
  getCouponHistoryPending: boolean
}

interface Redux {
  getState: () => any
  dispatch: ThunkDispatch<any, AxiosMiddlewareExtras, Action<string>>
  extra: AxiosMiddlewareExtras
}

interface CouponHistoryResponse {
  data: GygCouponHistoryType[]
}

export const getCouponHistoryByUserId = createAsyncThunk<CouponHistoryResponse, string, Redux>(
  GET_COUPON_HISTORY_BY_USER_ID_ACTION,
  async (userId: string, { extra }) => {
    const response = await extra.httpClient(`users/${userId}/coupons`)

    return response.data
  }
)

const initialState: GygCouponHistoryStateType = {
  gygCouponHistory: [],
  getCouponHistoryPending: false
}

export const gygCouponHistorySlice = createSlice({
  name: COUPON_HISTORY_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getCouponHistoryByUserId.fulfilled, (state, action) => {
        state.getCouponHistoryPending = false
        state.gygCouponHistory = action.payload.data
      })
      .addCase(getCouponHistoryByUserId.pending, state => {
        state.getCouponHistoryPending = true
      })
      .addCase(getCouponHistoryByUserId.rejected, state => {
        state.getCouponHistoryPending = false
      })
  }
})

export default gygCouponHistorySlice.reducer
